/* eslint-disable radix */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable function-paren-newline */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable operator-linebreak */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import { useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  Grid,
  Card,
  CardContent,
  Tooltip,
  Autocomplete,
  Switch,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import NumberFormat from 'react-number-format';
import Progress from '../../components/Progress';
import deLocale from 'date-fns/locale/pt-BR';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import DialogCicleStatus from '../../components/Dialogs/dialogCycleConcluido';
import moment from 'moment';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import { transferSchema } from './schemas';
import { POND_STATUS_CYCLE } from 'utils/consts';
import { labelField } from 'utils';

function Transfer() {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );
  const location = useLocation();
  const [pondCycles, setPondCycles] = useState([]);
  const [pondFilter, setPondFilter] = useState([]);
  const [filterPondCycles, setFilterPondCycles] = useState([]);
  const [originPondCycle, setOriginPondCycle] = useState(null);
  const [destinyPondCycle, setDestinyPondCycle] = useState(null);
  const [selectedDate, handleDateChange] = useState(new Date());
  const [openProgress, setOpenProgress] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const disable = useSelector((state) => state.disable.disable);

  const error = Error();
  const success = Success();
  const [openDialogCycleStatus, setOpenDialogCycleStatus] = useState(false);
  const [openDialogRemnantDied, setOpenDialogRemnantDied] = useState(false);
  let { id } = useParams();
  const [isPercentage, setIsPercentage] = useState(false);
  const [transferComplet, setTransferComplet] = useState(false);
  const fieldName = isPercentage ? 'Percentual' : 'Qtde de animais';
  const [value, setValue] = useState(0);
  const [inputValue, setInputValue] = useState('');
  const [quantityValue, setQuantityValue] = useState('');

  useEffect(() => {
    const filtered = pondCycles.filter(
      (pond) => pond?.id !== originPondCycle?.id
    );
    setFilterPondCycles(filtered);
  }, [originPondCycle]);

  useEffect(() => {
    if (location.state !== undefined) {
      location.state.data?.transfer_type === 'total'
        ? setTransferComplet(true)
        : setTransferComplet(false);
      location.state.data?.quantity_display === 'percentual'
        ? setIsPercentage(true)
        : setIsPercentage(false);
      if (location.state.customData) {
        location.state.customData?.transfer_type === 'total'
          ? setTransferComplet(true)
          : setTransferComplet(false);
        location.state.customData?.quantity_display === 'percentual'
          ? setIsPercentage(true)
          : setIsPercentage(false);
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    setOriginPondCycle(data.origin);
    setDestinyPondCycle(data.destiny);
    formik.values.origin = data.origin.id;
    formik.values.destiny = data.destiny.id;
    formik.values.date = data.date;
    formik.values.quantity = parseInt(data.quantity);
    formik.values.old = data.old;
    formik.values.sample_size = data.sample_size;
    formik.values.average_weight = data.average_weight;
    formik.values.transfer_type = data.transfer_type;
    formik.values.quantity_display = data.quantity_display;
    // formik.setValues(data);
    handleDateChange(moment(data.date, 'YYYY-MM-DD').toDate());
    handleDateChange(moment(data.date, 'YYYY-MM-DD').toDate());
  }

  useEffect(() => {
    api.get(`/cycles/cycle-code/${selectedCycle.id}`).then((pondCycles_) => {
      setPondCycles(
        pondCycles_.data.filter(
          (pond) =>
            pond.status === POND_STATUS_CYCLE.CULTIVANDO ||
            pond.status === POND_STATUS_CYCLE.PREPARANDO
        )
      );
    });
  }, [selectedCycle]);

  useEffect(() => {
    // filtrar viveiros que tenham biometrias pra preencher o viveiro de origem
    api
      .get(`/cycles/cycle-code/${selectedCycle.id}/biomeasures`)
      .then((pondCyclesFilter) => {
        setPondFilter(
          pondCyclesFilter.data.filter(
            (pond) =>
              pond.status === POND_STATUS_CYCLE.CULTIVANDO ||
              pond.status === POND_STATUS_CYCLE.PREPARANDO
          )
        );
      });
  }, [selectedCycle]);

  async function handleFilterPondsOrigin(originId) {
    // Retorna a idade dos animais
    const teste = await api.get(`/lots/cycle/${originId}`);
    formik.setFieldValue('old', teste.data.old || 0);
    // Retorna os dados do viveiro de origem
    const returnPondsOrigin = await api.get(`/biomeasures/last/${originId}`);
    formik.setFieldValue('sample_size', returnPondsOrigin.data.sample_size);
    formik.setFieldValue(
      'average_weight',
      returnPondsOrigin.data.average_weight
    );
  }

  async function request(data) {
    data.quantity =
      calculatePercentage(formik.values.quantity) || inputValue || value;
    data.transfer_type = transferComplet ? 'total' : 'parcial';
    data.quantity_display = isPercentage ? 'percentual' : 'padrão';
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      // eslint-disable-next-line no-unused-expressions
      id
        ? await api.put(`/transfers/${id}`, { ...data }).then(() => {
            setOpenDialogCycleStatus(true);
          })
        : await api.post('/transfers', { ...data }).then(() => {
            setOpenDialogCycleStatus(true);
          });
      success();
      // history.push('/transfers')
    } catch (err) {
      error(err.response.data.message);
      console.error(err);
    }
    dispatch(setDisable(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      origin: '',
      destiny: '',
      date: '',
      quantity: '',
      old: '',
      average_weight: '',
      sample_size: '',
      transfer_type: '',
      quantity_display: '',
    },
    validationSchema: transferSchema({ originPondCycle }),
    onSubmit: (values) => {
      if (originPondCycle?.population === formik.values.quantity) {
        setTransferComplet(true);
      }
      // eslint-disable-next-line no-param-reassign
      values.date = moment(selectedDate).format('YYYY-MM-DDT00:00:00[Z]');
      // eslint-disable-next-line no-param-reassign
      values.origin = originPondCycle.id;
      // eslint-disable-next-line no-param-reassign
      values.destiny = destinyPondCycle.id;
      if (transferComplet) setOpenDialogCycleStatus(true);
      request(values);
    },
  });

  useEffect(() => {
    if (originPondCycle?.population === formik.values.quantity) {
      setTransferComplet(true);
    }
  }, [formik.values.quantity]);

  const handleChange = (event) => {
    setIsPercentage(event.target.checked);
    setQuantityValue('');
  };

  const handleValueChange = (values) => {
    setQuantityValue(values.value); // modificando para atualizar quantityValue
    setInputValue(values.value);
  };

  const handleInputBlur = () => {
    const parsedValue = parseFloat(inputValue);
    setValue(parsedValue);
  };

  const calculatePercentage = () => {
    if (isPercentage) {
      const percentage = (value * originPondCycle?.population) / 100;
      return +percentage.toFixed();
    }
    return formik.values.quantity;
  };

  const calculatePercentageGet = (absolute) => {
    const percentage = (absolute / originPondCycle?.population) * 100;
    return +percentage.toFixed();
  };

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  const previousPondRef = useRef(null);

  useEffect(() => {
    if (
      pondCycles.length > 0 &&
      location.state.pond &&
      location.state.pond !== previousPondRef.current
    ) {
      previousPondRef.current = location.state.pond;
      const findPondCycles = pondCycles.find((item) =>
        item.pond.description.includes(location.state.pond.description)
      );
      setOriginPondCycle(findPondCycles);
      formik.setFieldValue('origin', findPondCycles?.id);
    }
  }, [formik, location.state.pond, pondCycles]);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados da Transferência
              <HtmlTooltip
                title=" Nessa tela você consegue transferir animais do viveiro de  origem para o viveiro de destino."
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>

            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={5}>
                  <FormGroup>
                    <Autocomplete
                      noOptionsText="Nenhum viveiro configurado para esse ciclo."
                      name="origin"
                      options={pondFilter}
                      value={originPondCycle}
                      getOptionLabel={(options) => options.pond.description}
                      onChange={(p, v) => {
                        if (v === destinyPondCycle) {
                          setDestinyPondCycle(null);
                          formik.values.destiny = null;
                        }
                        setOriginPondCycle(v);
                        formik.values.origin = v?.id;
                        handleFilterPondsOrigin(v?.id);
                      }}
                      onBlur={formik.handleBlur}
                      disabled={!!id}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                          label={labelField(
                            'Viveiro Origem',
                            'Antes de realizar uma transferência deve-se realizar ao menos uma biometria.'
                          )}
                          variant="outlined"
                          onBlur={formik.handleBlur}
                          error={formik.touched.origin && formik.errors.origin}
                          helperText={
                            formik.touched.origin && formik.errors.origin
                          }
                        />
                      )}
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <FormGroup>
                    <Autocomplete
                      name="destiny"
                      options={filterPondCycles}
                      value={destinyPondCycle}
                      getOptionLabel={(options) => options.pond.description}
                      disabled={!!(!formik.values.origin || id)}
                      onChange={(p, v) => {
                        setDestinyPondCycle(v);
                        formik.values.destiny = v?.id;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={labelField('Viveiro destino')}
                          variant="outlined"
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.destiny && formik.errors.destiny
                          }
                          helperText={
                            formik.touched.destiny && formik.errors.destiny
                          }
                        />
                      )}
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <FormGroup>
                    <LocalizationProvider
                      adapterLocale={deLocale}
                      dateAdapter={DateFnsUtils}
                    >
                      <DatePicker
                        id="date"
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        label={<div>Data de Transferencia</div>}
                        variant="inline"
                        inputVariant="outlined"
                        invalidDateMessage="Data Inválida"
                        value={selectedDate}
                        onChange={(date) => handleDateChange(date)}
                        onBlur={formik.handleBlur}
                        format="dd/MM/yyyy"
                        fullWidth
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormGroup>
                </Grid>

                <Grid item xs={5}>
                  <div style={{ fontWeight: 'bold' }}>
                    Tipo de Transferência:
                  </div>
                  <Grid
                    container
                    xs
                    direction="row"
                    alignItems="center"
                    width="100%"
                    gap="10px"
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        background: '#eeeeee',
                        borderRadius: '12px',
                        padding: '5px 12px',
                        width: 'auto',
                        border: '1.4px solid #a7a7a7',
                      }}
                    >
                      <span>Parcial</span>
                      <Switch
                        onChange={(e) => setTransferComplet(!transferComplet)}
                        checked={transferComplet}
                        disabled={!!id}
                      />
                      <span>Total</span>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        background: '#eeeeee',
                        borderRadius: '12px',
                        padding: '5px 12px',
                        width: 'auto',
                        border: '1.4px solid #a7a7a7',
                      }}
                    >
                      <span>Quantidade</span>
                      <Switch
                        onChange={handleChange}
                        checked={isPercentage || null}
                        disabled={!!id}
                      />
                      <span>Percentual</span>
                    </div>
                  </Grid>
                </Grid>

                <Grid item xs>
                  <FormGroup>
                    {transferComplet ? (
                      <NumberFormat
                        inputProps={{ maxLength: 11 }}
                        disabled
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        id="quantity"
                        label={labelField(fieldName, 'Percentual de animais')}
                        variant="outlined"
                        name="quantity"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={0}
                        value={
                          originPondCycle && originPondCycle.population
                            ? originPondCycle.population
                            : formik.values.quantity
                        }
                        onValueChange={(values) => {
                          formik.setValues({
                            ...formik.values,
                            quantity: values.floatValue,
                          });
                        }}
                        onBlur={formik.handleBlur}
                        customInput={TextField}
                        error={
                          !!(formik.touched.quantity && formik.errors.quantity)
                        }
                        helperText={
                          formik.touched.quantity && formik.errors.quantity
                        }
                      />
                    ) : isPercentage ? (
                      <NumberFormat
                        disabled={!!id}
                        value={
                          quantityValue ||
                          calculatePercentageGet(formik.values.quantity) ||
                          inputValue ||
                          value
                        }
                        label={labelField(fieldName, 'Percentual de animais')}
                        onValueChange={handleValueChange}
                        onBlur={handleInputBlur}
                        thousandSeparator="."
                        decimalSeparator=","
                        customInput={TextField}
                        inputProps={{ maxLength: 4 }}
                        suffix={isPercentage ? '%' : ''}
                      />
                    ) : (
                      <NumberFormat
                        inputProps={{ maxLength: 11 }}
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        id="quantity"
                        label={labelField(fieldName)}
                        variant="outlined"
                        name="quantity"
                        thousandSeparator="."
                        decimalSeparator=","
                        disabled={!!id}
                        decimalScale={0}
                        value={formik.values.quantity}
                        onValueChange={(values) => {
                          formik.setValues({
                            ...formik.values,
                            quantity: values.floatValue,
                          });
                        }}
                        onBlur={formik.handleBlur}
                        customInput={TextField}
                        error={
                          !!(formik.touched.quantity && formik.errors.quantity)
                        }
                        helperText={
                          formik.touched.quantity && formik.errors.quantity
                        }
                      />
                    )}
                  </FormGroup>
                </Grid>

                <Grid item xs>
                  <FormGroup>
                    <NumberFormat
                      allowNegative={false}
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="old"
                      label={labelField('Idade', 'Idade (em dias) dos animais')}
                      variant="outlined"
                      name="old"
                      value={formik.values.old}
                      disabled
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={0}
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          old: values.floatValue,
                        });
                      }}
                      fullWidth
                      onBlur={formik.handleBlur}
                      customInput={TextField}
                      error={!!(formik.touched.old && formik.errors.old)}
                      helperText={
                        formik.touched.old &&
                        formik.errors.old &&
                        formik.errors.old
                      }
                    />
                  </FormGroup>
                </Grid>

                {/* peso medio */}
                <Grid item xs={12} sm={2}>
                  <FormGroup>
                    <NumberFormat
                      inputProps={{ maxLength: 7 }}
                      fullWidth
                      customInput={TextField}
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="pmvo"
                      label={
                        <div>
                          Peso médio
                          <HtmlTooltip
                            title={
                              <>
                                Peso médio do Viveiro Origem: Esse peso médio é
                                referente a última biometria realizada do
                                Viveiro Origem.
                              </>
                            }
                            placement="right"
                            arrow
                          >
                            <HelpIcon color="primary" fontSize="inherit" />
                          </HtmlTooltip>
                        </div>
                      }
                      variant="outlined"
                      name="pmvo"
                      value={formik.values.average_weight}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={0}
                      onBlur={formik.values.handleBlur}
                      error={formik.values.average_weight >= 100000}
                      helperText={
                        formik.values.average_weight >= 100000
                          ? 'Limite ultrapassado (4 números)'
                          : null
                      }
                      suffix={formik.values.average_weight ? 'g' : ''}
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          average_weight: values.floatValue,
                        });
                      }}
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <FormGroup>
                    <NumberFormat
                      inputProps={{ maxLength: 4 }}
                      fullWidth
                      customInput={TextField}
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="tavo"
                      label={
                        <div>
                          Tamanho da amostra
                          <HtmlTooltip
                            title={
                              <>
                                Tamanho da amostra Viveiro Origem: Essa amostra
                                é referente à última biometria realizada no
                                Viveiro Origem.
                              </>
                            }
                            placement="right"
                            arrow
                          >
                            <HelpIcon color="primary" fontSize="inherit" />
                          </HtmlTooltip>
                        </div>
                      }
                      variant="outlined"
                      name="tavo"
                      value={formik.values.sample_size}
                      // disabled={id ? true : false}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={0}
                      onBlur={formik.values.handleBlur}
                      error={formik.values.sample_size >= 1000}
                      helperText={
                        formik.values.sample_size >= 1000
                          ? 'Limite ultrapassado (4 números)'
                          : null
                      }
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          sample_size: values.floatValue,
                        });
                      }}
                    />
                  </FormGroup>
                </Grid>

                {openDialogCycleStatus ? (
                  <DialogCicleStatus
                    id={originPondCycle.id}
                    dialogRemnantDied={setOpenDialogRemnantDied}
                    historyPush="/transfers"
                    end={selectedDate}
                  />
                ) : null}
              </Grid>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/transfers/"
            routeDelete="/transfers"
            returnRoute="/transfers"
            messageDialogError="Não é possível excluir esta transferência, pois este ciclo possui mortalidade."
            id={id}
            disable={disable}
            message="A exclusão dessa transferência pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Transfer;
